import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material';
import { BillingScheduleCollectionResponse } from '@acorn-portal/shared/src/services/managedPaymentsApi';
import { format } from 'date-fns';
import { DISPLAY_DATE } from '@acorn-portal/shared/src/utils/constants';
import { formatCurrency } from '@acorn-portal/shared/src/utils';
import { PaymentScheduleDetails, usePaymentSchedule } from '@acorn-portal/shared/src/components/paymentDetails';
import { Visibility } from '@mui/icons-material';

interface IFullPaymentScheduleTable {
	collections: BillingScheduleCollectionResponse[];
}

const FullPaymentScheduleTable: React.FC<IFullPaymentScheduleTable> = ({ collections }) => {
	const { sortedRows, getTextStyle, getDescription, getStatusText } = usePaymentSchedule(collections);

	const [openModal, setOpenModal] = useState(false);
	const [selectedCollection, setSelectedCollection] = useState<BillingScheduleCollectionResponse>(sortedRows[0]);

	const handleModalOpen = (collection: BillingScheduleCollectionResponse) => {
		setSelectedCollection(collection);
		setOpenModal(true);
	};

	return (
		<>
			<TableContainer
				sx={(theme) => ({
					my: 2,
					borderRadius: 3,
					border: `1px solid ${theme.palette.divider}`,
				})}
			>
				<Table aria-label='Payments Table'>
					<TableHead sx={{ '& th': { color: 'secondary.main', fontSize: '1.05rem' } }}>
						<TableRow>
							<TableCell>Collection Date</TableCell>
							<TableCell>Amount</TableCell>
							<TableCell>Payment Method</TableCell>
							<TableCell>Status</TableCell>
							<TableCell></TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{sortedRows.map((row) => (
							<TableRow
								key={row.reference}
								sx={{
									'& th': { ...getTextStyle(row) },
									'& td': { ...getTextStyle(row) },
								}}
							>
								<TableCell component='th' scope='row'>
									{format(new Date(row.scheduledDate), DISPLAY_DATE)}
								</TableCell>
								<TableCell>{formatCurrency(row.amount)}</TableCell>
								<TableCell>{getDescription(row)}</TableCell>
								<TableCell>{getStatusText(row)}</TableCell>
								<TableCell>
									<Button
										variant='text'
										onClick={() => handleModalOpen(row)}
										color='primary'
										sx={{ ':hover': { backgroundColor: 'unset' } }}
										startIcon={<Visibility />}
									>
										View More
									</Button>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
			<PaymentScheduleDetails open={openModal} onClose={() => setOpenModal(false)} collection={selectedCollection} />
		</>
	);
};

export default FullPaymentScheduleTable;
